<template>
  <div class="contents">
    <div class="container email-template-form-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
              <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                <h4 class="text-capitalize fw-500 breadcrumb-title">
                  {{ isCreate ? 'New Email Template' : 'Edit Email Template' }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div v-if="!isLoading" class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <form @submit.prevent="saveTemplate">
              <div class="row">
                <div class="col-md-6">
                  <label>Template Name</label>
                  <input v-model="form.name" type="text" class="form-control" required>
                </div>
                <div class="col-md-6">
                  <label>Type ID</label>
                  <input v-model="form.type_id" type="text" class="form-control" placeholder="service_expiring_7_days" required>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-4">
                  <label>Trigger Type</label>
                  <select v-model="form.trigger_type" class="form-control" required>
                    <option value="days_before_expired">Hari sebelum expired</option>
                    <option value="on_expired">Saat expired</option>
                    <option value="days_after_expired">Hari setelah expired</option>
                    <option value="on_reset_password">Reset password OTP</option>
                    <option value="manual">Manual / blast</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label>Trigger Days</label>
                  <input v-model.number="form.trigger_days" type="number" min="0" class="form-control" :disabled="!needsTriggerDays">
                </div>
                <div class="col-md-4">
                  <label>Status</label>
                  <select v-model="form.status" class="form-control" required>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <br>

              <label>Subject</label>
              <div class="email-var-toolbar">
                <span class="email-var-toolbar__label">Variabel:</span>
                <button
                  v-for="variable in availableVariables"
                  :key="'subject-' + variable.key"
                  type="button"
                  class="btn btn-sm btn-outline-primary email-var-chip"
                  @click="insertVariable('subject', variable.key)"
                >
                  {{ variable.label }}
                </button>
              </div>
              <input
                ref="subjectInput"
                v-model="form.subject"
                type="text"
                class="form-control"
                required
              >

              <br>
              <label>Body HTML</label>
              <div class="email-var-toolbar">
                <span class="email-var-toolbar__label">Variabel:</span>
                <button
                  v-for="variable in availableVariables"
                  :key="'body-' + variable.key"
                  type="button"
                  class="btn btn-sm btn-outline-primary email-var-chip"
                  @click="insertVariable('body', variable.key)"
                >
                  {{ variable.label }}
                </button>
              </div>
              <vue-editor
                ref="bodyEditor"
                v-model="form.body_html"
                :editor-toolbar="editorToolbar"
                class="email-template-editor"
              />

              <br>
              <div class="d-flex">
                <router-link to="/admin/email-template" class="btn btn-light mr-2">Batal</router-link>
                <button type="submit" class="btn btn-primary">Simpan</button>
              </div>
            </form>
          </div>
          <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <center><div class="spinner-border spinner" role="status"></div></center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

const EMAIL_VARIABLES = [
  { key: 'name', label: 'Nama' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Telepon' },
  { key: 'username', label: 'Username' },
  { key: 'expired_at', label: 'Tanggal Expired' },
  { key: 'service_name', label: 'Nama Layanan' },
  { key: 'paket', label: 'Paket' },
  { key: 'otp', label: 'OTP' },
]

export default {
  components: { VueEditor },
  data() {
    return {
      isLoading: true,
      isCreate: true,
      editorToolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean'],
      ],
      form: {
        name: '',
        type_id: '',
        subject: '',
        body_html: '',
        trigger_type: 'manual',
        trigger_days: 0,
        status: 'active',
      },
    }
  },
  computed: {
    needsTriggerDays() {
      return ['days_before_expired', 'days_after_expired'].includes(this.form.trigger_type)
    },
    availableVariables() {
      if (this.form.trigger_type === 'on_reset_password') {
        return EMAIL_VARIABLES
      }
      return EMAIL_VARIABLES.filter((v) => v.key !== 'otp')
    },
  },
  async mounted() {
    this.isCreate = this.$route.name === 'NewEmailTemplate'
    if (!this.isCreate) {
      await this.loadData()
    } else {
      this.isLoading = false
    }
  },
  methods: {
    variableToken(key) {
      return `{{${key}}}`
    },
    insertVariable(target, key) {
      const token = this.variableToken(key)
      if (target === 'subject') {
        this.insertIntoInput(this.$refs.subjectInput, 'subject', token)
        return
      }
      this.insertIntoEditor(token)
    },
    insertIntoInput(input, field, token) {
      if (!input) {
        this.form[field] = (this.form[field] || '') + token
        return
      }
      const value = this.form[field] || ''
      const start = typeof input.selectionStart === 'number' ? input.selectionStart : value.length
      const end = typeof input.selectionEnd === 'number' ? input.selectionEnd : start
      this.form[field] = value.slice(0, start) + token + value.slice(end)
      this.$nextTick(() => {
        input.focus()
        const pos = start + token.length
        input.setSelectionRange(pos, pos)
      })
    },
    insertIntoEditor(token) {
      const editor = this.$refs.bodyEditor
      const quill = editor?.quill
      if (!quill) {
        this.form.body_html = (this.form.body_html || '') + token
        return
      }
      const range = quill.getSelection(true)
      const index = range ? range.index : quill.getLength()
      quill.insertText(index, token)
      quill.setSelection(index + token.length)
    },
    stripHtml(html) {
      return (html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()
    },
    async loadData() {
      try {
        const id = this.$route.query.id
        const detail = await this.$store.dispatch('admin_email_template_detail', { id })
        this.form = { ...detail.data.data.template }
        this.isLoading = false
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Template tidak ditemukan')
        this.$router.push('/admin/email-template')
      }
    },
    async saveTemplate() {
      if (!this.stripHtml(this.form.body_html)) {
        this.$toast.error('Body HTML wajib diisi')
        return
      }
      try {
        let response
        if (this.isCreate) {
          response = await this.$store.dispatch('admin_email_template_create', this.form)
        } else {
          response = await this.$store.dispatch('admin_email_template_update', {
            id: this.$route.query.id,
            ...this.form,
          })
        }
        this.$toast.success(response.data.message)
        this.$router.push('/admin/email-template')
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal menyimpan template')
      }
    },
  },
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

.email-var-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin: 0.5rem 0 0.75rem;
}

.email-var-toolbar__label {
  font-size: 0.8125rem;
  color: var(--wc-text-muted, #6c757d);
  margin-right: 0.15rem;
}

.email-var-chip {
  font-size: 0.75rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
}

.email-template-editor {
  border: 1px solid #ced4da !important;
  border-radius: var(--wc-radius-md, 8px);
  overflow: hidden;
  background: #fff;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
}

.email-template-editor >>> .ql-toolbar.ql-snow {
  border: none !important;
  border-bottom: 1px solid #ced4da !important;
  background: var(--wc-bg-subtle, #f8f9fa);
}

.email-template-editor >>> .ql-container.ql-snow {
  border: none !important;
  min-height: 280px;
  font-size: 0.9375rem;
}

.email-template-editor >>> .ql-editor {
  min-height: 280px;
}
</style>
